import './index.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { RadioBox as RadioBox$1 } from '@vds/core';
import styles from './radio-box.module.scss.js';
import CheckmarkBold from '../../icons/component-icons/checkmark-bold/index.js';

const RadioBox = (props) => {
    const { surface, showIndicator = true, padding = '3X' } = props, rest = __rest(props, ["surface", "showIndicator", "padding"]);
    const mappedSurface = (surface === null || surface === void 0 ? void 0 : surface.includes('dark')) ? 'dark' : 'light';
    const RadioBoxWrapperStyles = [styles.radioBoxWrapper];
    const CheckmarkWrapperStyles = [
        styles.checkmarkWrapper,
        styles[mappedSurface],
    ];
    if (props === null || props === void 0 ? void 0 : props.showIndicator)
        RadioBoxWrapperStyles.push(styles.showIndicator);
    const inlinePadding = padding.toLowerCase();
    return (jsxs("div", { className: RadioBoxWrapperStyles.join(' '), style: {
            width: props === null || props === void 0 ? void 0 : props.width,
            '--padding': `var(--vds-space-${inlinePadding})`,
        }, children: [(props === null || props === void 0 ? void 0 : props.selected) && showIndicator && (jsx("div", { className: CheckmarkWrapperStyles.join(' '), style: {
                    '--margin-right': `var(--vds-space-${inlinePadding})`,
                    '--margin-top': `var(--vds-space-${inlinePadding})`,
                }, children: jsx(CheckmarkBold, { size: "12", color: `var(--vds-color-element-primary-on${(surface === null || surface === void 0 ? void 0 : surface.includes('dark')) ? 'light' : 'dark'}primary)` }) })), jsx(RadioBox$1, Object.assign({}, rest, { 
                // subtextRight is set blank when showIndicator is true to allow indicator to take its space
                sublabelRight: showIndicator ? ' ' : props === null || props === void 0 ? void 0 : props.sublabelRight, surface: surface }))] }));
};

export { RadioBox as default };
